<template>
  <div class="map-main">
    <div class="addr-box">
      <div style="display: flex; align-items: center"><p v-if="location">位置：{{ location }}</p></div>
      <div style="display: flex; align-items: center">
        <el-input style="margin-right: 16px; width: 24em" v-model="searchValue">
          <template #prepend>搜索</template>
        </el-input>
        <ElButtons type="warning" icon="search" @click="getPlaceSearch()"> 查询 </ElButtons>
<!--        <ElButtons type="warning" icon="search" @click="getGeocoder(this.searchValue)"> 查询 </ElButtons>-->
      </div>
    </div>

    <div id="container"></div>
    <div id="panel"></div>
    <div class="dialog-footer" style="text-align: center; ">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
export default {
  name: "BaiduMap",
  props: {
    value: Object
  },
  data() {
    return {
      // map: null
      addr: this.value.addr,
      location: this.value.location,
      searchValue: '',
      lnglat: this.value.lnglat,

      map: null,
      AMap: null,
      marker: null,
    }
  },
  methods: {

    cancel() {
      this.map?.destroy();
      this.$emit("close");
    },

    initAMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "2d34d9f83bbc28fd0c9e256e1c7f3456",
      };
      AMapLoader.load({
        key: "44bf4dddb0194160f1814cb45e9258ca", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.ToolBar", "AMap.Scale", "AMap.AutoComplete", "AMap.PlaceSearch"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
          .then((AMap) => {
            this.AMap = AMap
            this.map = new AMap.Map("container", {
              // 设置地图容器id
              // viewMode: "3D", // 是否为3D地图模式
              zoom: 15, // 初始化地图级别
              center: [113.264499, 23.130061], // 初始化地图中心点位置
            });
            var toolbar = new AMap.ToolBar(); //创建工具条插件实例
            this.map.addControl(toolbar); //添加工具条插件到页面
            var scale = new AMap.Scale();
            this.map.addControl(scale);

            this.marker = new AMap.Marker();

            // this.getGeocoder()
            this.regeoCode(this.addr)

            let _this = this
            this.map.on('click',function(e){
              console.log(e)
              _this.lnglat = e.lnglat;
              _this.regeoCode();
            })

          })
          .catch((e) => {
            console.log(e);
          });
    },

    getPlaceSearch() {
      let _this = this
      _this.AMap.plugin(["AMap.PlaceSearch"], function() {
        //构造地点查询类
        var placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          city: "020", // 兴趣点城市
          citylimit: true,  //是否强制限制在设置的城市内搜索
          map: _this.map, // 展现结果的地图实例
          panel: "panel", // 结果列表将在此容器中进行展示。
          autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        });
        //关键字查询
        placeSearch.search(_this.searchValue);
        placeSearch.on('listElementClick', function (e) {
          console.log(e)
          _this.location = e.data.name
          _this.lnglat = e.data.location
          // _this.addr = e.data.cityname + e.data.adname + e.data.address
        })
      });
    },

    getGeocoder(addr) {
      let _this = this
      _this.AMap.plugin('AMap.Geocoder', function() {
        let geocoder = new AMap.Geocoder({
          city: '020' // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
        })

        let address = addr;

        // _this.marker = new AMap.Marker();

        geocoder.getLocation(address, function(status, result) {
          if (status === 'complete' && result.info === 'OK') {
            // result中对应详细地理坐标信息
            console.log(result)

            let lnglat = result.geocodes[0].location
            _this.marker.setPosition(lnglat);
            _this.map.add(_this.marker);
            _this.map.setFitView(_this.marker);
            _this.lnglat = lnglat
            _this.location = result.geocodes[0].formattedAddress
          }
        })
      })
    },

    regeoCode() {
      let _this = this
      _this.AMap.plugin('AMap.Geocoder', function() {
        let geocoder = new AMap.Geocoder({
          city: '020',// city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          radius: 1000
        })

        // let marker = new AMap.Marker();
        console.log(_this.lnglat)

        let lnglat  = _this.lnglat
        _this.marker.setPosition(lnglat);
        _this.marker.setTitle(_this.location);
        _this.map.add(_this.marker);
        _this.map.setFitView(_this.marker);

        geocoder.getAddress(lnglat, function(status, result) {
          if (status === 'complete'&&result.regeocode) {
            console.log(result)
            // let address = result.regeocode.formattedAddress;
            _this.location = result.regeocode.formattedAddress;
          }
        });

      })

    },

    summit() {
      if(!this.lnglat) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '门店地址不能为空',
          type: 'warning'
        });
        return false
      }
      this.map?.destroy();
      this.$emit('confirm', {lnglat: this.lnglat, location: this.location, addr: this.addr})

    }


  },
  mounted() {
    this.initAMap();



  },
  unmounted() {
    this.map?.destroy();
  },
}
</script>

<style scoped>
#container{
  padding:0px;
  margin: 0px;
  width: 100%;
  height: 500px;
}

.map-main {
  position: relative;
}

.addr-box {
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

#panel {
  position: absolute;
  background-color: white;
  max-height: 90%;
  overflow-y: auto;
  top: 60px;
  right: 10px;
  width: 300px;
}

</style>
